module.exports = __webpack_public_path__ + "static/media/lumedx.f6d062a1.ico";